import { FetchPlaceUseCase } from '@/module/place/domain/usecase/fetch_place_usecase';
import { FetchEngineUseCase } from '../domain/usecase/fetch_engine_usecase';
import { DeleteEngineUseCase } from '../domain/usecase/delete_engine_usecase';
import { CreateEngineUseCase } from '../domain/usecase/create_engine_usecase';
import { ChangeEngineUseCase } from '../domain/usecase/change_engine_usecase';
import { EnginePagination } from '../domain/model/engine_pagination';
import { DataOptions } from 'vuetify';
import { headers } from '../const/headers';
import { Engine } from '../domain/model/engine';
import { snackbar } from '@/core/controller/snackbar_controller';
import { PlacePagination } from '@/module/place/domain/model/place_pagination';

import { CompanyPagination } from '@/module/company/domain/model/company_pagination';
import { FetchCompanyUseCase } from '@/module/company/domain/usecase/fetch_company_usecase';
import { itemStatus, visibilityStatus } from '@/core/domain/model/pagination';

class EngineController {
  public context: any;
  public status: number = 0
  public showForm: boolean = false;
  public columns: Array<any> = headers
  public search: string = ""
  public searchPlace: string  = ""
  public searchCompany: string  = ""
  public flagOption: string = ""
  public loading: boolean = false
  public loadingLogs: boolean = false
  public groupBy: string = ""
  public menuGroup: boolean = false
  public selectedEngine: Engine | null = null
  
  public loadingBtnExcel : boolean = false
  public visibilityStatus = visibilityStatus
  public itemStatus = itemStatus
  public enginePagination: EnginePagination = {
    total: 0,
    items: []
  }
  public placePagination: PlacePagination = {
    total: 0,
    items: []
  }
  public companyPagination: CompanyPagination = {
    total: 0,
    items: []
  }
  public options: DataOptions = {
    page: 1,
    itemsPerPage: 40,
    groupBy: [],
    sortBy: ["name"],
    groupDesc: [],
    multiSort: false,
    mustSort: false,
    sortDesc: []
  }
  public optionsPlace: DataOptions = {
    page: 1,
    itemsPerPage: 10,
    groupBy: [],
    sortBy: ["name"],
    groupDesc: [],
    multiSort: false,
    mustSort: false,
    sortDesc: []
  }
  public optionsTracking: DataOptions = {
    page: 1,
    itemsPerPage: 40,
    groupBy: [],
    sortBy: ["createdDate"],
    groupDesc: [],
    multiSort: false,
    mustSort: false,
    sortDesc: [true]
  }
  public optionsCompany: DataOptions = {
    page: 1,
    itemsPerPage: 10,
    groupBy: [],
    sortBy: ["name"],
    groupDesc: [],
    multiSort: false,
    mustSort: false,
    sortDesc: []
  }

  public engine: Engine = {
    name: "", place_id: 0, company_id: 0
  }

  private fetchPlaceUseCase: FetchPlaceUseCase
  private fetchEngineUseCase: FetchEngineUseCase
  private deleteEngineUseCase: DeleteEngineUseCase
  private createEngineUseCase: CreateEngineUseCase
  private changeEngineUseCase: ChangeEngineUseCase
  private fetchCompanyUseCase: FetchCompanyUseCase

  constructor(context: any, fetchPlaceUseCase: FetchPlaceUseCase, fetchEngineUseCase: FetchEngineUseCase, deleteEngineUseCase: DeleteEngineUseCase, createEngineUseCase: CreateEngineUseCase, changeEngineUseCase: ChangeEngineUseCase, fetchCompanyUseCase: FetchCompanyUseCase) {
    this.context = context
    this.fetchPlaceUseCase = fetchPlaceUseCase
    this.fetchEngineUseCase = fetchEngineUseCase
    this.deleteEngineUseCase = deleteEngineUseCase
    this.createEngineUseCase = createEngineUseCase
    this.changeEngineUseCase = changeEngineUseCase
    this.fetchCompanyUseCase = fetchCompanyUseCase
  }

  openForm(engine: Engine | null) {
    if (engine) this.engine = { ...engine }

    this.showForm = true
  }

  closeForm(){
    this.showForm = false

    this.context.$refs.form.resetValidation()
    this.engine = {
      name: "", place_id: 0, company_id: 0
    }
  }

  async paginate() {
    this.loading = true

    try {
      this.enginePagination = await this.fetchEngineUseCase(this.options, this.search, this.status)
    } catch (error: any) {
      snackbar.show({ message: error.toString() })
    } finally {
      this.loading = false
    }
  }

  async paginatePlace() {
    try {
      const search = this.searchPlace ? this.searchPlace : ""
      this.placePagination = await this.fetchPlaceUseCase(this.optionsPlace, search)
    } catch (error: any) {
      snackbar.show({ message: error.toString() })
    }
  }

  async paginateCompany() {
    try {
      const search = this.searchCompany ? this.searchCompany : ""
      this.companyPagination = await this.fetchCompanyUseCase(this.optionsCompany, search)
    } catch (error: any) {
      snackbar.show({ message: error.toString() })
    }
  }

  watchOptions() {
    this.paginate()
  }

  watchSearch() {
    this.paginate()
  }
  watchOptionsPlace() {
    this.paginatePlace()
  }

  watchSearchPlace() {
    this.paginatePlace()
  }

  watchSearchCompany() {
    this.paginateCompany()
  }

  watchOptionsCompany() {
    this.paginateCompany()
  }

  async save() {
    if (this.context.$refs.form.validate()) {
      try {
        const snackBarProps = {
          message: Boolean(this.engine.id) ? "Alterado com sucesso!" : "Criado com sucesso!",
          color: Boolean(this.engine.id) ? "blue" : "green",
          timeout: 1500
        }

        if (this.engine?.id) {
          await this.changeEngineUseCase(this.engine.id, this.engine)
        } else {
          await this.createEngineUseCase(this.engine)
        }

        this.paginate()
        snackbar.show(snackBarProps)
      } catch (error: any) {
        snackbar.show({ message: error.toString() })
      } finally {
        this.closeForm()
      }
    }
  }

  async delete(item: Engine) {
    try {
      const confirm = await snackbar.confirm({
        message: "Deseja realmente excluir o registro?",
        color: 'red',
        timeout: 5000
      })

      if (confirm) {
        await this.deleteEngineUseCase(item.id)
        this.paginate()
        snackbar.show({ message: "Resgistro excluído com sucesso!", color: 'primary', timeout: 1000 })
      }
    } catch (error: any) {
      snackbar.show({ message: error.toString() })
    }
  }
}

export default EngineController
